import * as yup from 'yup';
import dayjs from "dayjs";

import {
    propFieldTypes as injectionPropFieldTypes
} from "../../../../hooks/api/useInjectionProps"

import {
    fieldDataTypes as injectionFieldDataTypes,
    moduleTypes as injectionFieldModuleTypes
} from "../../../../hooks/api/useInjectionFields"

export const containerSizes = {
    twentyFt: {
        id: "twentyFt",
        display: "20Ft",
        value: "20Ft"
    },
    fortyFt: {
        id: "fortyFt",
        display: "40Ft",
        value: "40Ft"
    },
}

export const containerTypes = {
    mixedLCL: {
        id: "mixedLCL",
        display: "散柜 LCL",
        value: "散柜 LCL"
    },
    fullFCL: {
        id: "fullFCL",
        display: "全柜 FCL",
        value: "全柜 FCL"
    },
    shipLCL: {
        id: "shipLCL",
        display: "船公司 LCL",
        value: "船公司 LCL"
    },
}

const defCustomInjectionFields = { ref: injectionFieldModuleTypes.repository.container.ref, module: injectionFieldModuleTypes.repository.container.module }

export const customInjectionFields = {
    containerSize: { submitKey: "container_size", retrieveKey: "inf_repo_cont_container_size", fieldDataTypeId: injectionFieldDataTypes.value.id, ...defCustomInjectionFields },
    containerType: { submitKey: "container_type", retrieveKey: "inf_repo_cont_container_type", fieldDataTypeId: injectionFieldDataTypes.value.id, ...defCustomInjectionFields },

    totalCbm: { submitKey: "total_cbm", retrieveKey: "inf_repo_cont_total_cbm", fieldDataTypeId: injectionFieldDataTypes.numeric.id, ...defCustomInjectionFields },
    totalValue: { submitKey: "total_value", retrieveKey: "inf_repo_cont_total_value", fieldDataTypeId: injectionFieldDataTypes.numeric.id, ...defCustomInjectionFields },
    totalWeight: { submitKey: "total_weight", retrieveKey: "inf_repo_cont_total_weight", fieldDataTypeId: injectionFieldDataTypes.numeric.id, ...defCustomInjectionFields },
    totalPackQty: { submitKey: "total_pack_qty", retrieveKey: "inf_repo_cont_total_pack_qty", fieldDataTypeId: injectionFieldDataTypes.numeric.id, ...defCustomInjectionFields },

    sourceContainerRemId: { submitKey: "source_container_remid", retrieveKey: "inf_repo_cont_source_container_remid", fieldDataTypeId: injectionFieldDataTypes.value.id, ...defCustomInjectionFields },
}

export const customInjectionPropsBk = {

    containerSize: {
        submitKey: "container_size",
        retrieveKey: "inj_repo_cont_container_size",
        propFieldId: injectionPropFieldTypes.value.id,
        propFieldName: injectionPropFieldTypes.value.fieldName,
        propIsMultiple: 0,
        getValue: (val) => {
            return val
        }
    },

    containerType: {
        submitKey: "container_type",
        retrieveKey: "inj_repo_cont_container_type",
        propFieldId: injectionPropFieldTypes.value.id,
        propFieldName: injectionPropFieldTypes.value.fieldName,
        propIsMultiple: 0,
        getValue: (val) => {
            return val
        }
    },

    // scheduler
    sourceContainerRemId: {
        submitKey: "source_container_remid",
        retrieveKey: "inj_repo_cont_source_container_remid",
        propFieldId: injectionPropFieldTypes.value.id,
        propFieldName: injectionPropFieldTypes.value.fieldName,
        propIsMultiple: 0,
        getValue: (val) => {
            return val
        }
    }

}

// temp override this
export const customInjectionProps = customInjectionFields

export const validationSchema = yup.object({
    locationId: yup
        .string()
        .required("Required"),
    toLocationId: yup
        .string()
        .required("Required"),
    repoNumber: yup
        .string()
        .required("Required"),
    repoAlternativeNumber: yup
        .string()
        .required("Required"),
    numberSeal: yup
        .string()
        .required("Required"),
    repoMarking: yup
        .string()
        .required("Required"),
    initialDate: yup
        .date("Invalid")
        .required("Required")
        .typeError("Invalid"),
    loadDate: yup
        .date("Invalid")
        .required("Required")
        .typeError("Invalid"),
    supervisor: yup
        .string()
        .required("Required"),
    shipper: yup
        .string()
        .required("Required"),
    customAgent: yup
        .string()
        .required("Required"),
    containerSize: yup
        .string()
        .required("Required"),
    containerType: yup
        .string()
        .required("Required"),
    // rows: yup.array().of(validateRowSchema)

})

export const initialRowValues = {
    id: 0,
    itemId: "",
    qty: "",
    itemName: "",
    code: "",
    description: "",
    itemRemark: "",
    uomLabel: "",
    uomId: "",
    price: ""
}

export const initialValues = {
    repoNumber: "",
    repoAlternativeNumber: "",
    numberSeal: "",
    repoMarking: "",
    initialDate: dayjs(),
    loadDate: dayjs(),
    supervisor: "",
    shipper: "",
    customAgent: "",
    remark: "",
    // rows: [initialRowValues],
    locationId: "",
    locationName: "",
    toLocationId: "",
    toLocationName: "",

    containerSize: "",
    containerType: ""
} 